<template>
  <tbody>
    <tr
      class="is-border-top">
      <td class="has-text-centered">
        <avatar
          :use-picto-custom="'fas fa-city'"
          :is-avatar="false"
          :use-picto="'fas fa-city'"
          :item="a.program"
          class="has-background-grey-light is-medium has-text-white">
        </avatar>
      </td>
      <td>
        <router-link :to="{name: 'ProgramVue', params: {id: a.program.pk}}">
          {{ a.program.name }}
        </router-link>
      </td>
      <td v-if="!fromAgence">
        {{ a.start_date | date }}
      </td>
      <td v-if="!fromAgence">
        {{ a.end_date | date }}
      </td>
      <td v-if="fromAgence">
        {{ a.created_on | date }}
      </td>
      <td class="is-narrow">
        <span
          v-if="!fromAgence && filteredAllotments.length"
          class="tag is-allotement is-uppercase">
          {{ filteredAllotments.length }} {{ 'Lot' | pluralize(filteredAllotments.length > 1) }} {{ 'Alloté' | pluralize(filteredAllotments.length > 1) }}
        </span>
        <span
          v-if="fromAgence && access_allotement.length"
          class="tag is-allotement is-uppercase">
          {{ access_allotement.length }} {{ 'Lot' | pluralize(access_allotement.length > 1) }} {{ 'visible' | pluralize(access_allotement.length > 1) }} sur ce programme
        </span>
      </td>
      <td
        class="is-paddingless is-marginless"
        :style="'width: 150px;'">
        <div
          class="field has-addons is-border-left">
          <div
            v-if="!fromAgence || (fromAgence && a.remuneration > 0)"
            class="control is-expanded has-incrementations">
            <span
              class="input is-borderless is-medium is-padding-top-small has-text-centered is-fullwidth">
              {{ a.remuneration }}
            </span>
          </div>
          <div
            v-if="!fromAgence || (fromAgence && a.remuneration > 0)"
            class="control">
            <a class="button is-static is-borderless is-square is-medium">
              <span class="icon"><i class="fas fa-percentage"></i></span>
            </a>
          </div>
          <div
            :style="fromAgence && a.remuneration == 0 ? 'margin-left: 68%;' : null"
            class="dropdown is-hoverable is-right"
            v-if="!editRem && !editAccess && !loading">
            <div class="dropdown-trigger">
              <button
                class="button is-square is-medium is-radiusless is-borderless"
                aria-haspopup="true"
                aria-controls="dropdown-menu">
                <i class="fal fa-ellipsis-v"></i>
              </button>
            </div>
            <div
              class="dropdown-menu"
              role="menu">
              <div class="dropdown-content has-text-left">
                <a
                  v-if="isPromoteur"
                  class="dropdown-item"
                  @click="selectEditedAccess">
                  <span class="icon is-size-5"><i class="fas fa-edit"></i></span>
                  <span
                    v-if="fromAgence"
                    class="is-margin-left-xsmall">Modifier allotement</span>
                  <span
                    v-else
                    class="is-margin-left-xsmall">Modifier mandat</span>
                </a>
                <a
                  class="dropdown-item has-background-danger has-text-white"
                  @click="checkSubmitDelete">
                  <span class="icon is-size-5"><i class="fas fa-trash-alt"></i></span>
                  <span
                    v-if="fromAgence"
                    class="is-margin-left-xsmall">Retirer ce programme</span>
                  <span
                    v-else
                    class="is-margin-left-xsmall">Supprimer mandat</span>
                </a>
              </div>
            </div>
          </div>
          <div
            class="control"
            v-if="editRem && !loading">
            <a
              id="submitRemunerationAccess"
              class="button is-square is-medium is-success is-min-width-0 has-hover-black"
              @click="updateAccess">
              <span class="icon is-size-5"><i class="fas fa-save"></i></span>
            </a>
          </div>
          <div
            class="control"
            v-if="(editRem || editAccess) && !loading">
            <a
              class="button is-square is-medium is-draft is-min-width-0"
              @click="cancelEditAccess">
              <span class="icon is-size-5 has-text-white"><i class="fas fa-times"></i></span>
            </a>
          </div>
          <div
            class="control"
            v-if="loading">
            <button class="button is-square is-medium is-primary is-min-width-0 has-hover-black is-loading">
              <span class="icon"><i class="fas fa-lg fa-spinner-third"></i></span>
            </button>
          </div>
        </div>
      </td>
    </tr>
    <tr v-if="editAccess">
      <td
        colspan="7"
        class="box3 is-paddingless">
        <mandat-form
          :editaccessalert="editAccess"
          :editaccess="a"
          :editallotments="fromAgence ? access_allotement : filteredAllotments"
          :from-agence="fromAgence ? true : false"
          @afterupdate="afterUpdate">
        </mandat-form>
      </td>
    </tr>
    <slot></slot>
  </tbody>
</template>

<script>
import { GenericList, DefaultValues } from '@/mixins'
import { mapGetters } from 'vuex'
import { cloneDeep, debounce } from 'lodash'

export default {
  name: 'MandatVue',
  components: {
    MandatForm: () => import('@/components/mandat/MandatForm')
  },
  mixins: [GenericList, DefaultValues],
  props: {
    allotments: {
      type: Array
    },
    source: Object,
    selectedAccess: String,
    agence: Object,
    fromAgence: Boolean
  },
  data () {
    return {
      a: null,
      service: 'MANDAT',
      savedAccess: null,
      editAccess: false,
      editRem: false,
      allotments_data: null,
      access_allotement: null
    }
  },
  computed: {
    ...mapGetters(['canAddUsers', 'isPromoteur']),
    groupTabLinks () {
      let tabs = []
      tabs.push({ link: 'MandatList', label: 'Mandat' })
      return tabs
    },
    filteredAllotments () {
      return this.allotments_data.filter(x => this.source.pk.includes(x.mandat))
    }
  },
  watch: {
    source (v) {
      this.a = v
      this.savedAccess = cloneDeep(v)
      this.editAccess = false
      this.editRem = false
    },
    selectedAccess (v) {
      if (v !== this.a.pk) {
        this.cancelEditAccess()
      }
    }
  },
  created () {
    if (this.source) {
      this.access_allotement = this.allotments
      this.allotments_data = this.allotments
      this.editAccess = false
      this.editRem = false
      this.a = this.source
      this.savedAccess = cloneDeep(this.source)
    }
  },
  methods: {
    changeView (link) {
      this.$router.push({ name: link })
    },
    /**
      * select edit Access
      */
    selectEditedAccess () {
      this.editAccess = true
      this.$emit('selectedAccess', this.a.pk)
    },
    /**
      * edit remuneration
      */
    selectEditedRem: debounce(function () {
      this.editRem = true
      this.$emit('selectedAccess', this.a.pk)
    }, 400),
    /**
      * update access allotment
      * @param {object}
      */
    updateAccessAllotment (access) {
      this.$emit('updateAccessAllotment', access)
    },
    /**
      * update access
      */
    updateAccess () {
      this.editAccess = false
      this.editRem = false
      this.$emit('updateAccess', this.a)
    },
    /**
      * cancel edit access
      */
    cancelEditAccess () {
      this.editAccess = false
      this.editRem = false
      this.a = cloneDeep(this.savedAccess)
    },
    /**
      * after update mandat
      */
    async afterUpdate (mandatdata) {
      if (this.fromAgence) {
        this.editAccess = false
        this.access_allotement = mandatdata.lots
        this.tabs = 'MANDATS_LIST_VUE'
      } else {
        this.editAccess = false
        let params = { sales_channel: mandatdata.sales_channel.pk }
        let { data } = await this.$api.get(this.$resources.ALLOTMENT_ALL, params)
        this.allotments_data = data.all_allotment
        this.tabs = 'MANDATS_LIST_VUE'
      }
    },
    checkSubmitDelete () {
      if (this.fromAgence) {
        return this.deleteAccessAgence()
      } else {
        return this.deleteAccess()
      }
    },
    /**
      * delete access
      */
    async deleteAccess (pk) {
      let value = await this.$swal({
        title: 'Suppression mandat',
        text: 'La société n\'aura plus accès au programme, cette action entrainera également l\'annulation de ses options sur ce programme.',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        try {
          await this.$api.axios.delete(`/mandat-type/${this.a.pk}`)
          this.$toasted.global.success('Mandat supprimé')
          this.$emit('afterdelete', this.a.pk)
        } catch (err) {
          this.handleError(err)
          console.log(err)
        }
      }
    },
    /**
      * delete agence
      */
    async deleteAccessAgence () {
      let value = await this.$swal({
        title: 'Suppression programme',
        text: 'Les utilisateurs présent dans l\'agence n\'auront plus accès au programme',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false
      if (value) {
        try {
          await this.$api.axios.delete(`/agence-access/${this.a.pk}`)
          this.$toasted.global.success('Programme supprimé')
          this.$emit('afterdelete', this.a.pk)
        } catch (err) {
          this.handleError(err)
          console.log(err)
        }
      }
    },
    /**
      * select input
      * @param {string}
      */
    selectInput (input) {
      if (input in this.$refs) {
        if (Array.isArray(this.$refs[input])) {
          this.$refs[input][0].select()
        } else {
          this.$refs[input].select()
        }
      }
    }
  }
}
</script>
